/**
 * @generated SignedSource<<fc7d5bd602fc313a071d9a5e7d1e7e99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FindAvailabilityConfigInput = {
  practitionerUserId: string;
};
export type userAvailabilityConfigQuery$variables = {
  input: FindAvailabilityConfigInput;
};
export type userAvailabilityConfigQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"userAvailabilityConfigQueryFragment">;
};
export type userAvailabilityConfigQuery = {
  variables: userAvailabilityConfigQuery$variables;
  response: userAvailabilityConfigQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userAvailabilityConfigQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "userAvailabilityConfigQueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userAvailabilityConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "UserAvailabilityConfig",
        "kind": "LinkedField",
        "name": "findAvailabilityConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "18789ce0f7a1b31564fddbef2ebe5a41",
    "id": null,
    "metadata": {},
    "name": "userAvailabilityConfigQuery",
    "operationKind": "query",
    "text": "query userAvailabilityConfigQuery(\n  $input: FindAvailabilityConfigInput!\n) {\n  ...userAvailabilityConfigQueryFragment\n}\n\nfragment userAvailabilityConfigFragment on UserAvailabilityConfig {\n  id\n  duration\n}\n\nfragment userAvailabilityConfigQueryFragment on Query {\n  findAvailabilityConfig(input: $input) {\n    ...userAvailabilityConfigFragment\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7910bb302660d81946b45d5ca9abf5ad";

export default node;
